import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ProductImage } from './ProductImage';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 px-4 overflow-hidden bg-slate-950" data-id="element-46">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-900/30 blur-[120px] rounded-full pointer-events-none" data-id="element-47"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-49">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-200 leading-tight mb-6" data-id="element-50">
            Kit Ortopedista PRO
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-4 max-w-2xl mx-auto" data-id="element-51">
          <ProductImage data-id="element-52" />
          <p className="text-center text-xl md:text-2xl text-slate-300 font-semibold mt-6" data-id="element-53">
            Sistema profesional de evaluación y seguimiento en ortopedia
          </p>
          <p className="text-center text-lg md:text-xl text-slate-400 font-medium mt-3" data-id="element-54">
            Mejorá tu consultorio en una semana
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-55">
          <CTAButton data-id="element-56" />
        </motion.div>
      </div>
    </section>;
}